import {rankList, rankInData, relationData} from '@/runtime-components/data';

const components = [
	{
		title: '填充组件',
		tag: 'de-text-bar',
		group: 'complex',
		defaultSize:{
			width: 80, 
			height: 150
		},
		props: [
			{
				title: '颜色',
				name: 'color',
				type: {name: 'color'},
				default: '#34f2da'
			}
		]
	},
	{
		title: '圆环组件',
		tag: 'de-text-circle',
		group: 'complex',
		defaultSize:{
			width: 100, 
			height: 150
		},
		props: [
			{
				title: '比例',
				name: 'percent',
				type: {
					name: 'number', 
					options: {
						max:100,
						min:0
					}
				},
				default: 30,
			},
			{
				title: '环背景色',
				name: 'circleBackground',
				type: {name: 'color'},
				default: '#073978'
			},
			{
				title: '圆环颜色',
				name: 'circleFrontColor',
				type: {name: 'color'},
				default: '#018CFB'
			}
		]
	},
    {
		title: '排名组件',
		tag: 'de-rank',
		group: 'complex',
		defaultSize:{
			width: 220, 
			height: 60
		},
		props: [
			{
				title: '内容',
				name: 'rankItem',
				type: {name: 'rank'},
				default: {
					option: '0-5公里',
					color: 'linear-gradient(-45deg, #038CFB 0%, #102FA8 100%)',
					percent: 59.4,
					total: 3527,
					key: 1
				}
			},
			{
				title: '字体',
				name: 'fontObj',
				type: {name: 'font'},
				default: {
					fontSize: 12,
                    fontFamily: "PingFang",
                    fontWeight: "normal",
                    fontStyle: "normal",
                    color: "#fff"
				}
			},
			{
				title: '内容间距',
				name: 'margin',
				type: {name: 'number'},
				default: 10
			},
			{
				title: '柱子长度',
				name: 'barWidth',
				type: {name: 'number'},
				default: 80
			},
			{
				title: '数据',
				name: 'item',
				type: {
					name:"data-json",
				},
				default: {
					option: '0-5公里',
					color: 'linear-gradient(-45deg, #038CFB 0%, #102FA8 100%)',
					percent: 59.4,
					total: 3527,
					key: 1
				}
			}
		]
    },
    {
		title: '排名列表组件',
		tag: 'de-rank-list',
		group: 'complex',
		defaultSize: {
			width: 494,
			height: 200
		},
		props: [
			{
				title: '内容间距',
				name: 'margin',
				type: {name: 'number'},
				default: 16
			},
			{
				title: '柱子长度',
				name: 'barWidth',
				type: {name: 'number'},
				default: 80
			},
			{
				title: '数据',
				name: 'rankList',
				type: {
					name:"data-json",
				},
				default: rankList
			}
		]
	},
	{
		title: '图文组件',
		tag: 'de-picture-text',
		group: 'complex',
		defaultSize:{
			width: 200, 
			height: 86
		},
		props: [
			{
				title: '标题',
				name: 'labelProp',
				type: {name: 'text'},
				default: ''
			},
			{
				title: '内容',
				name: 'percentProp',
				type: {name: 'text'},
				default: ''
			},
			{
				title: '字体大小',
				name: 'fontSize',
				type: {name: 'number'},
				default: 16
			},
			{
				title: '圆环大小',
				name: 'width',
				type: {name: 'number'},
				default: 80
			},
			{
				title: '内容间距',
				name: 'margin',
				type: {name: 'number'},
				default: 28
			},
			{
				title: '更换内容',
				name: 'content',
				type: {
					name: 'select',
					options: {
						list: [{
							label: '商旅',
							percent: 32.77,
							value: require('@/runtime-components/assets/images/business.png')
						}, {
							label: '常驻',
							percent: 67.23,
							value: require('@/runtime-components/assets/images/people.png')
						}]
					}
				},
				default: {
					label: '商旅',
					percent: 32.77,
					value: require('@/runtime-components/assets/images/business.png')
				}
			},
		]
	},
	{
		title: '图文占比',
		tag: 'de-ratio',
		props:[
			{
				title: '值',
				name: 'percent',
				type: {
					name: 'number', 
					options: {
						max:100,
						min:0
					}
				},
				default: 50,
			},
			{
				title: '文字',
				name: 'label',
				type: {name: 'text'},
				default: ''
			},
			{
				title: '圆环背景色',
				name: 'circleBackground',
				type: {name: 'color'},
				default: '#073978'
			},
			{
				title: '圆环前景色',
				name: 'circleFrontColor',
				type: {name: 'color'},
				default: '#018CFB'
			},
			{
				title: '文字样式',
				name: 'font',
				type: {name: 'font'},
				default: {
					fontSize: 24,
					fontStyle: 'normal',
					color: '#ffffff'
				}
			}
		]
	},
	{
		title: '排行组件',
		tag: 'de-simple-rank-in',
		group: 'complex',
		defaultSize: {
			width: 360,
			height: 470
		},
		props:[
			{
				title: '字体',
				name: 'fontObj',
				type: {
					name: 'font'
				},
				default: {
					fontSize: 12,
					fontStyle: 'normal',
					color: '#ffffff'
				}
			},
			{
				title: '内容间距',
				name: 'padding',
				type: {
					name: 'number'
				},
				default: 10
			},
			{
				title: '数据间距',
				name: 'margin',
				type: {
					name: 'number'
				},
				default: 12
			},
			{
				title: '数据条数',
				name: 'length',
				type: {
					name: 'number',
					options: {
						min: 0
					}
				},
				default: 10
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json',
				},
				default: rankInData
			}
		]
	},
	{
		title: '胶囊排行组件',
		tag: 'de-rank-easy',
		group: 'complex',
		defaultSize: {
			width: 350,
			height: 380
		},
		props:[
			{
				title: '是否显示序号',
				name: 'showIndex',
				default: false
			},
			{
				title: '是否显示百分比',
				name: 'showPercent',
				default: false
			},
			{
				title: '是否千分位',
				name: 'isFormat',
				type: {
					name: 'switch'
				},
				default: true
			},
			{
				title: '背景色',
				name: 'backColor',
				type: {
					name: 'color'
				},
				default: 'transparent'
			},
			{
				title: '字体',
				name: 'fontObj',
				type: {
					name: 'font'
				},
				default: {
					fontSize: 12,
					fontStyle: 'normal',
					color: '#fff'
				}
			},
			{
				title: '内容间距',
				name: 'padding',
				type: {
					name: 'number'
				},
				default: 6
			},
			{
				title: '数据间距',
				name: 'margin',
				type: {
					name: 'number'
				},
				default: 10
			},
			{
				title: '柱子颜色',
				name: 'color',
				type: {
					name: 'color'
				},
				default: '#FFC653'
			},
			{
				title: '柱子高度',
				name: 'barSize',
				default: 1
			},
			{
				title: '柱子圆角',
				name: 'borderRadius',
				default: 4
			},
			{
				title: '数据条数',
				name: 'length',
				type: {
					name: 'number',
					options: {
						min: 0
					}
				},
				default: 10
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json',
				},
				default: rankInData
			}
		]
	},
	{
		title: '关联排行表',
		tag: 'de-relation-rank',
		group: 'complex',
		defaultSize: {
			width: 660,
			height: 300
		},
		props:[
			{
				title: '标题1',
				name: 'option1',
				type: {
					name: 'text',
				},
				default: '智能电视'
			},
			{
				title: '标题2',
				name: 'option2',
				type: {
					name: 'text',
				},
				default: '电视盒子'
			},
			{
				title: '标题3',
				name: 'option3',
				type: {
					name: 'text',
				},
				default: '机顶盒'
			},
			{
				title: '数据',
				name: 'data',
				type: {
					name: 'data-json',
				},
				default: relationData
			}
		]
	},
	{
		title: '圆环趋势组件',
		tag: 'de-circle-trend',
		group: 'complex',
		defaultSize: {
			width: 170,
			height: 90
		},
		props:[
			{
				title: '圆环内容',
				name: 'title',
				type: {
					name: 'text'
				},
				default: '治愈'
			},
			{
				title: '文本总数',
				name: 'total',
				type: {
					name: 'number'
				},
				default: 56127
			},
			{
				title: '总数单位',
				name: 'unit',
				type: {
					name: 'text'
				},
				default: '例'
			},
			{
				title: '文本',
				name: 'pre',
				type: {
					name: 'text'
				},
				default: '昨日'
			},
			{
				title: '增减数目',
				name: 'changeNumber',
				type: {
					name: 'number'
				},
				default: 27
			},
			{
				title: '字体',
				name: 'fontObj',
				type: {
					name: 'font'
				},
				default: {
					fontSize: 16,
					fontStyle: 'normal',
					color: '#fff'
				}
			},
			{
				title: '圆环大小',
				name: 'circleWidth',
				type: {
					name: 'number'
				},
				default: 80
			},
			{
				title: '圆环粗细',
				name: 'borderWidth',
				type: {
					name: 'number'
				},
				default: 10
			},
			{
				title: '圆环颜色',
				name: 'borderColor',
				type: {
					name: 'color'
				},
				default: 'royalblue'
			}
		]
	}
]
export default components;